import type { ComponentContentSchema } from '@vibesites/runtime';
import {
  useBlockSlot,
  EditableToken,
  SectionContextProvider,
} from '@vibesites/runtime/react';

// ─── Component ────────────────────────────────────────────────────────────────
//
// Plain wrapper around the RealPage Online Leasing (OLL) widget. The widget is
// a third-party script shipped as the `realpage-oll` Integrations block; this
// component just gives it a section to render in beneath the hero. Like
// ApartmentSync but with no client-side post-processing — it only hosts the
// block.

export function RealpageOLL() {
  const blockSlot = useBlockSlot('realpageoll.block', {
    defaultValue: 'realpage-oll',
  });

  return (
    <section className="bg-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <EditableToken
          path="realpageoll.block"
          type="block"
          label="Online Leasing Block"
          acceptedBlockCategories={['Integrations']}
          as="div"
        >
          {blockSlot ? (
            <SectionContextProvider sectionId={blockSlot.sectionId}>
              <blockSlot.BlockComponent sectionId={blockSlot.sectionId} />
            </SectionContextProvider>
          ) : (
            <div className="text-center font-body text-[var(--vibe-color-text)]/60">
              No online leasing block selected
            </div>
          )}
        </EditableToken>
      </div>
    </section>
  );
}

// ─── Content Schema ───────────────────────────────────────────────────────────

export const contentSchema: ComponentContentSchema = {
  slot: 'RealpageOLL',
  displayName: 'RealPage Online Leasing',
  tokens: {
    'realpageoll.block': {
      label: 'Online Leasing Block',
      type: 'block',
      defaultValue: 'realpage-oll',
      acceptedBlockCategories: ['Integrations'],
    },
  },
};

(RealpageOLL as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default RealpageOLL;
